export default __webpack_public_path__ + "static/media/339.126320af.png";